import { DateStringNumber, Nullable } from "common/records";
import { QueryParamsRecord, queryParamsFromJSON } from "common/records/QueryParams";

export const orgIncludes = [
  "address",
  "settings",
  "preferences",
  "lead_sources",
  "job_types",
  "job_states",
  "contract_languages",
];
export const orgOverviewIncludes = ["address"];
export const userIncludes = orgIncludes.concat(["permissions", "org"]);
export const jobIncludes = orgIncludes.concat([
  "org",
  "customer_address",
  "assignments",
  "job_types",
  "estimate_comparison",
]);
export const jobOverviewIncludes = ["address", "assignments", "appointments", "job_types"];
export const estimateIncludes = ["line_items", "finance_option"];

export interface IBaseData {
  id: number;
  selected: boolean;
  loading: boolean;
  _destroy: boolean;
  sort_order: Nullable<number>;
  errors: string[];
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export const baseCleanProps = <T extends Partial<IBaseData>>(params: T): T => {
  if (params.id !== undefined && params.id <= 0) {
    delete params.id;
  }

  if (params.sort_order === null || params.sort_order === undefined) delete params.sort_order;
  if (!params._destroy) delete params._destroy;

  delete params.selected;
  delete params.loading;
  delete params.errors;
  delete params.created_at;
  delete params.updated_at;

  return params;
};

export const listParams = (queryParams: QueryParamsRecord): any => {
  let params: any = { sort_by: "sort_order", sort_order: "asc" };

  if (!queryParams.equals(queryParamsFromJSON({}))) {
    params = { ...params, ...queryParams.toJS() };
    delete params.parameters;
  }
  if (!params.folder_id) delete params.folder_id;
  if (!params.filter) delete params.filter;
  if (!params.query) delete params.query;

  return params;
};
